import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the "/diet" step of the breadcrumb on every page below it, not just on the list. */
export const Route = createFileRoute("/(private)/diet")({
  loader: () => ({ crumb: m.hub_nav_diet() }),
  component: Outlet,
});
